/**
 * Deduplicate in-flight requests by key. Reuses the same promise when the same key
 * is requested again before the first one resolves.
 */
const pending = new Map();

export function trackRequest(key, requestFn) {
  if (pending.has(key)) {
    return pending.get(key);
  }
  const promise = Promise.resolve()
    .then(() => requestFn())
    .finally(() => {
      pending.delete(key);
    });
  pending.set(key, promise);
  return promise;
}
